module.exports = __webpack_public_path__ + "img/a1.2fe13d89.png";